
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/noleggio-a-lungo-termine/faq/[slug]",
      function () {
        return require("private-next-pages/noleggio-a-lungo-termine/faq/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/noleggio-a-lungo-termine/faq/[slug]"])
      });
    }
  